import { Fragment } from "react";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { emptyStateString } from "@dzambalaorg/draft-js-utils";
import { useFetchData } from "@dzambalaorg/react-hooks";
import type { IContract } from "@framework/types";

import { ContractContent, CraftContactPanel } from "../../../../components";
import { Erc1155TemplateList } from "../template-list";

export const Erc1155Contract = () => {
  const {
    data: contract = {
      title: "",
      description: emptyStateString,
    } as IContract,
    isLoading,
  } = useFetchData<IContract>(`/erc1155/contracts`); // We don't use the id because it's embedded in the hook request.

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc1155", "erc1155.contract"]} data={[{}, {}, { title: contract.title }]} />

      <PageHeader message="pages.erc1155.contract.title" data={contract}>
        <CraftContactPanel contract={contract} />
      </PageHeader>

      <ContractContent contract={contract} />

      <Erc1155TemplateList embedded />
    </Fragment>
  );
};
